import "./general.css";
import { useScrollAnim } from "../hook/useScrollAnim";
import { useTranslation } from "react-i18next";

export default function HeroFooter(props) {
  const containerRef = useScrollAnim({
    selector: "nav",
    threshold: 0.3,
    once: true,
  });
  const { t } = useTranslation();

  return (
    <div ref={containerRef}>
      <nav className="heroFooter_section">
        <article>
          <h2 className="bold">{t("heroFooter.client")}</h2>
          <h1>{props.name}</h1>
        </article>
        <div>
          {props.link2display ? (
            <a
              href={props.link2url}
              target="_blank"
              rel="noreferrer"
              className="websiteBtn thin"
            >
              {props.link2name}
            </a>
          ) : (
            ""
          )}
          {props.link1display !== false && (
            <a
              href={props.link1url}
              target="_blank"
              rel="noreferrer"
              className="websiteBtn thin"
            >
              {t("heroFooter.website")}
            </a>
          )}
        </div>
      </nav>
    </div>
  );
}
